module.exports = __webpack_public_path__ + "img/tools-batch-hover.ffbc3346.png";